import { IModel } from '@/@types/models/model';
import coreFields from './helpers/coreFields';

const Poi: IModel = {
  title: 'Točke interesa',
  apiPath: 'cestovna-infrastruktura/poi',
  layer: 'tocke_interesa',
  forms: {
    default: {
      fields: [
        'path_poi_type_id',
        'active',
        'comment',
        'geom'
      ],
    },
    insert: {
      fields: [
        {source: 'path_poi_type_id', width: 'full'},
        'comment',
        'geom'
      ],
    },
  },
  listViews: {
    default: {
      fields: [
        'id',
        'path_poi_type_id',
        'active',
        'comment',
      ],
    },
  },
  fields: [
    coreFields.id,
    {
      title: 'path_poi_type_id',
      source: 'path_poi_type_id',
      ttoken: 'cestovna_infrastruktura:tocke_interesa.vrsta',
      type: 'picker',
      subModel: {
        apiPath: 'cestovna-infrastruktura/poi-types',
        format: '{label}',
        idattr: 'id'
      },
      translate: true,
      filter: true,
      validation: {
        required: true,
      },
    },
    {
      title: 'comment',
      source: 'comment',
      ttoken: 'core:common.comment',
      type: 'multiline',
      rows: 2,
      maxRows: 3,
      width: 'full',
    },
    coreFields.active,
    coreFields.gid,
    coreFields.created_by,
    coreFields.created_on,
    coreFields.modified_by,
    coreFields.modified_on,
    {
      title: 'Geometry',
      source: 'geom',
      ttoken: 'common.geometry',
      type: 'wkt',
      sourceProjection: 'EPSG:3857',
      targetProjection: 'EPSG:3857',
      readonly: true,
    },
  ],
};

export default Poi;
